<svelte:head>
  <title>Log in | A Good Thing</title>
</svelte:head>

<section class="section hero">
  <form on:submit|preventDefault={() => login()}>
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-two-fifths">
            <div class="card has-card-header-background">
              <header class="card-header">
                <p class="card-header-title">
                  <!-- svelte-ignore a11y-missing-attribute -->
                  <a href="https://www.agoodthing.org.uk/">
                    <img src="/assets/img/logo_h.png" />
                  </a>
                </p>
              </header>
              <div class="card-content">
                <div class="field">
                  <!-- svelte-ignore a11y-label-has-associated-control -->
                  <label class="label">Email address</label>
                  <div class="control">
                    <!-- svelte-ignore a11y-autofocus -->
                    <input
                      bind:value={email}
                      type="email"
                      autocomplete="on"
                      name="email"
                      class="input"
                      required
                      autofocus />
                  </div>
                </div>
                <div class="field">
                  <!-- svelte-ignore a11y-label-has-associated-control -->
                  <label class="label">Password</label>
                  <div class="control">
                    <input
                      bind:value={password}
                      type="password"
                      autocomplete="on"
                      name="password"
                      class="input"
                      required />
                  </div>
                </div>
                <hr />
                <div style="line-height:50px;">
                  <button
                    class="button is-primary"
                    class:is-loading={isLoading}
                    type="submit">Log in</button>
                  &nbsp;
                  {#if email}
                    <a  href={$url("/recover", { email })} class="button is-outlined">
                      Forgot password?
                    </a>
                  {:else}
                    <a  href="/recover" class="button is-outlined">
                      Forgot password?
                    </a>
                  {/if}
    
                  &nbsp;
                  <a href="/signup" class="button is-outlined"> Sign up </a>
                </div>
                {#if errorMessage}
                  <div class="notification is-danger is-light">
                    {errorMessage}
                  </div>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>

<script lang="ts">
  import { ga } from '@beyonk/svelte-google-analytics';
  import { url } from '@sveltech/routify';
  import { logging } from '../../lib/logging';

  let email :string, password :string, errorMessage :string | undefined;

  let isLoading = false;

  function login() {
    errorMessage = undefined;

    isLoading = true;

    window.firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        ga.addEvent('login', {});
      })
      .catch((err) => {
        errorMessage = err.message;
        ga.addEvent('error_login', { message: err.message });
        logging.setUser(email); // user has not succesfully logged on, but tag the error with the user id
        logging.report(new Error(err.message, { cause: err }));
      })
      .finally(() => {
        isLoading = false
      });
  }
</script>
